import downloadFiles, { FILE_DOWNLOAD_TYPES } from '../utils/downloadFiles';

import { api } from './apiInstances';

export const getFilesRequestSDS = async (id, monthly) => {
  const assignmentTypeQueryParam = monthly ? '&tipoAsignacion=3' : '';
  const result = await api.get(`/v1/ServiciosArchivoAdjunto?id=${id}${assignmentTypeQueryParam}`);

  return result.data;
};

export const postFilesRequestSDS = async ({ id, archivosAdjuntos, isMonthly }) => {
  // Be careful with the assignment type; tipoAsignacion=1 is being forced to prevent failures.
  const assignmentTypeQueryParam = isMonthly ? '&tipoAsignacion=3' : '&tipoAsignacion=1';
  const result = await api.post(
    `/v1/ServiciosArchivoAdjunto?id=${id}${assignmentTypeQueryParam}`,
    archivosAdjuntos,
    {
      headers: {
        Accept: '*/*'
      }
    }
  );

  return {
    success: true,
    data: result
  };
};

export const getFilesRequestPt = async (id, monthly) => {
  const assignmentTypeQueryParam = monthly ? '?tipoAsignacion=3' : '';
  const result = await api.get(
    `/v1/ServiciosArchivoAdjunto/${id}/partesTrabajo${assignmentTypeQueryParam}`
  );

  return result.data;
};

export const getOptionsMonthlyLocationFiles = async (id, query) => {
  const result = await api.get(
    `/v1/ServiciosArchivoAdjunto/solicitudMensualizada/${id}/ubicaciones?ubicacion=${query}`
  );

  return result.data;
};

export const getFilesByFilters = async (id, body) => {
  const bodyPost = {
    tipoAsignacion: body?.tipoAsignacion?.id ?? body?.tipoAsignacion,
    filtroArchivosAdjuntos: {
      fechaDesde: body?.filtroArchivosAdjuntos?.fechaDesde || null,
      fechaHasta: body?.filtroArchivosAdjuntos?.fechaHasta || null,
      ubicacion: body?.filtroArchivosAdjuntos?.ubicacion || null
    },
    ordenColumna: {
      nombre: body?.ordenColumna?.nombre || null,
      direccion: body?.ordenColumna?.direccion || null
    }
  };

  const result = await api.post(`/v2/ServiciosArchivoAdjunto/${id}/partesTrabajo`, bodyPost);

  return result.data;
};

export const postDownloadFilesSDS = async (oneFile, id, idsArchivos, monthly, downloadType) => {
  try {
    /**
     * El backend solo puede recibir el parametro 2 para descargas individuales, por eso
     * hay que sobreescribir el downloadType por el 2 si el usuario quiere abrirlo en el navegador,
     */
    const shouldOpenInBrowser = downloadType === FILE_DOWNLOAD_TYPES.BROWSER;
    const result = await api.post(
      `/v2/ServiciosArchivoAdjunto/${id}/download`,
      {
        idsArchivos,
        tipoDescarga: shouldOpenInBrowser ? 2 : downloadType,
        tipoAsignacion: monthly ? 3 : 1
      },
      {
        headers: {
          Accept: '*/*'
        },
        responseType: 'blob'
      }
    );

    downloadFiles(result.data, oneFile, downloadType);

    return {
      success: true,
      data: result
    };
  } catch (e) {
    if (e.result) {
      throw new Error(e.result);
    } else {
      throw new Error('Estamos experimentando problemas, por favor, intente más tarde.');
    }
  }
};

export const postWorkReportFiles = async (lineId, date, archivosAdjuntos, monthly, idUbicacion) => {
  const assignmentTypeQueryParam = monthly ? '&tipoAsignacion=3' : '';
  const idUbicacionQueryParam = idUbicacion ? `&idUbicacion=${idUbicacion}` : '';
  const baseUrl = '/v1/ServiciosArchivoAdjunto/partesTrabajo/lineas';
  const result = await api.post(
    `${baseUrl}/${lineId}?fecha=${date}${assignmentTypeQueryParam}${idUbicacionQueryParam}`,
    archivosAdjuntos,
    {
      headers: {
        Accept: '*/*'
      }
    }
  );

  return result.data;
};

export const deleteFilesRequestSDS = (id, idsArchivos, monthly) => {
  const QueryParams = monthly ? `?id=${id}&tipoAsignacion=3` : `?id=${id}`;

  return api
    .post(`/v1/ServiciosArchivoAdjunto/deletion${QueryParams}`, idsArchivos)
    .then((response) => ({
      success: true,
      data: response.data
    }))
    .catch((error) => ({
      success: false,
      message: error.message
    }));
};

export const postPendingAuthorizationFilesWorkReport = async (body) => {
  const collectIds = (data) => {
    const uniqueIds = [];

    data.lineas.forEach((linea) => {
      linea.idParteTrabajoDiariosCostos.forEach((id) => {
        uniqueIds.push(id);
      });
    });

    return uniqueIds;
  };

  const bodyIds = collectIds(body);
  const result = await api.post(`v1/ServiciosArchivoAdjunto/partesTrabajoDiarioCostos`, bodyIds);

  return result.data;
};
